export default __webpack_public_path__ + "static/media/counter-icon-2.077f0ba3.svg";